// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2v91Y","Meta":"Card_Meta__3Z6Lr","FAIL":"Card_FAIL__Xk8J8","PASS":"Card_PASS__2x4_3","Summary":"Card_Summary__ETZ4r","LotSample":"Card_LotSample__1-9oh"};